/**
 * Retry configuration for failed queries.
 * - `false`: Disable retries entirely
 * - `number`: Retry up to this many times
 * - `function`: Custom retry logic that receives (failureCount, error) and returns boolean
 */
export type RetryValue =
  | boolean
  | number
  | ((failureCount: number, error: unknown) => boolean);

export interface QueryOptions {
  staleTime?: number;
  retryDelay?: number;
  /**
   * Configure retry behavior for failed queries.
   *
   * By default, Cairo retries all failed queries up to 3 times.
   *
   * @example
   * // Disable retries entirely
   * queryOptions: { retry: false }
   *
   * @example
   * // Custom retry logic
   * queryOptions: {
   *   retry: (failureCount, error) => {
   *     // Only retry on 5xx server errors
   *     if (isHttpError(error) && error.response?.status >= 500) {
   *       return failureCount < 3;
   *     }
   *     return false;
   *   }
   * }
   */
  retry?: RetryValue;
}
